'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';
import replaceSearchParams from '@/utils/replaceSearchParams';

const useClearPrintRequested = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  return useCallback(() => {
    if (searchParams.get('print') !== 'true') {
      return;
    }

    const params = new URLSearchParams(searchParams);
    params.delete('print');

    replaceSearchParams(pathname, params);
  }, [pathname, searchParams]);
};

export default useClearPrintRequested;
